// extracted by mini-css-extract-plugin
export var mergingIntoPill = "_mw-1";
export var rowFirst = "_mw-3";
export var rowLast = "_mw-5";
export var rowMiddle = "_mw-4";
export var ticketListScroll = "_mw-2";
export var ticketStack = "_mw-0";